import { ACTION_TYPES, APP_NAME } from '~/core/constants'
import analytics from '~/services/analytics'

// Starting to gradually move analytics tracking here
const WHITELISTED_ACTIONS = {
  // the APP_NAME prefix should eventually be moved in trackEvent implementation
  // Right now we need to keep the existing event names in order to preserve existing charts integrity
  [ACTION_TYPES.RECENTS.SET_PLAYING_RECORDING]: `[${APP_NAME}] Open recording`,
  [ACTION_TYPES.UI.SET_MEETINGS_TAB]: `[${APP_NAME}] Set active tab`,
  [ACTION_TYPES.UI.SET_DIALOG]: `[${APP_NAME}] Set dialog`
}

export default () => next => action => {
  if (Object.keys(WHITELISTED_ACTIONS).includes(action.type)) {
    analytics.trackEvent(WHITELISTED_ACTIONS[action.type], null, action.payload)
  }

  next(action)
}
